<div class="row">
  <div class="col">
    @if (status === FileUploadStatus.Error) {
      <div role="alert" class="alert alert-danger p-3">
        An error has occurred, sanctions database not updated.
        @if (uploadResult.errorCells) {
          <span>
            The following cells must be "key" or "other": [{{ uploadResult.errorCells.join(', ') }}]
          </span>
        }
        @if (!uploadResult.isValidColumns) {
          <span>
            Please ensure your file contains the following columns: "Red Flag Indicator",
            "Territory", "Key or Other"
          </span>
        }
      </div>
    }

    @if (status === FileUploadStatus.Complete) {
      <div role="alert" class="alert alert-success p-3">
        Sanctions database updated successfully. Modified
        {{ uploadResult.sanctionedEntitiesAffected }} sanctioned entities and
        {{ uploadResult.redFlagsAffected }} red flags.
      </div>
    }
  </div>
</div>

<wre-file-upload></wre-file-upload>

<div class="row mt-3">
  <div class="col d-flex justify-content-center">
    <button
      type="button"
      class="btn wre-btn btn-primary"
      (click)="onFileSubmitted()"
      [disabled]="status !== FileUploadStatus.FileSelected">
      Submit
    </button>
  </div>
</div>
